import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import Home from '#/views/Home/Home';
import PageWrapper from '#/components/layout/PageWrapper/PageWrapper';
import { RoutesNames } from './routes';
import Characters from '#/views/Characters';
import Comics from '#/views/Comics';
import Stories from '#/views/Stories';
import CharacterDetails from '#/views/CharacterDetails';
import ComicDetails from '#/views/ComicDetails';
import StoryDetails from '#/views/StoryDetails';
import Bookmarks from '#/views/Bookmarks';
import NotFound from '#/views/NotFound';

const router = createBrowserRouter([
  {
    path: RoutesNames.HOME,
    element: <PageWrapper />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: RoutesNames.CHARACTERS,
        element: <Characters />,
      },
      {
        path: `${RoutesNames.CHARACTERS}/:characterId`,
        element: <CharacterDetails />,
      },
      {
        path: RoutesNames.COMICS,
        element: <Comics />,
      },
      {
        path: `${RoutesNames.COMICS}/:comicId`,
        element: <ComicDetails />,
      },
      {
        path: RoutesNames.STORIES,
        element: <Stories />,
      },
      {
        path: `${RoutesNames.STORIES}/:storyId`,
        element: <StoryDetails />,
      },
      {
        path: RoutesNames.BOOKMARKS,
        element: <Bookmarks />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);

export default router;
